var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8781 12.3215C15.0332 12.1152 15.0409 11.8334 14.8977 11.6188C14.0322 10.3176 12.712 9.38616 11.1956 9.00755L10.8913 8.93147C10.6838 8.87916 10.4645 8.93979 10.3129 9.09137L9.49736 9.90216C9.17103 10.216 8.65506 10.216 8.32872 9.90216L6.09605 7.67131C5.77506 7.34794 5.77506 6.82603 6.09605 6.50266L6.90862 5.69187V5.69128C7.06139 5.5391 7.12261 5.31739 7.06852 5.10874L6.99244 4.80439C6.61379 3.28802 5.68233 1.96774 4.38116 1.10233C4.16657 0.95907 3.88482 0.966799 3.67856 1.12194L3.37421 1.3502C1.8834 2.47367 1.00489 4.23084 1.00002 6.09785C0.99586 7.67254 1.62178 9.18347 2.73813 10.2945L5.70549 13.2619C6.81647 14.3782 8.32741 15.0041 9.90209 15C11.7692 14.9958 13.5262 14.1173 14.6497 12.6258L14.8781 12.3215ZM9.90218 13.7826C8.65032 13.7861 7.44901 13.2886 6.56626 12.4011L3.59891 9.43375C2.71144 8.55102 2.2139 7.34973 2.21747 6.09781C2.22104 4.64028 2.89452 3.26602 4.04354 2.36957C4.90783 3.05672 5.52425 4.00847 5.79824 5.0784L5.23651 5.64132C4.43938 6.44023 4.43938 7.7337 5.23651 8.53261L7.46918 10.7635C8.277 11.538 9.55211 11.538 10.3604 10.7635L10.9293 10.1958C11.9975 10.4728 12.9456 11.091 13.6304 11.9564C12.734 13.1055 11.3597 13.7791 9.90218 13.7826Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4378708e5264a5ddb41575dbc7b0da00.svg";
export { ForwardRef as ReactComponent };